<template>
	<!-- <div class="fulldiv"> -->
	<el-container  style="height: 100%;">
		
		<!-- <el-header class="logo">
			<div>logo</div>
		</el-header> -->
		<!-- <div class="fullheigt"> -->
		<el-main  class="nopading fullheigt">
			<el-menu class="el-menu-vertical-m10" :collapse="isCollapse" mode="vertical" :default-active="TabReal">
				<!-- :default-active="currentTabIndex" --spaniner-->
				<!-- 多层 -->
				<!-- {{menuList}} -->
				<template v-for="(item,index) in menuList">
					<el-submenu  :key="index" :index="item.menuId" v-if="item.sub&&item.sub.length>=1&&(!item.qx||item.qx.includes(userinfo.accountType))" ref="subitem" 
					:style="'background-color:var(--main_color);'">
						<template slot="title">
							<i :class="iconfonts[index]?iconfonts[index]:iconfonts[7]+ ' _text_color'"></i><!-- item._icon -->
							<span class="_text_color">{{item.title}}</span>
						</template>
						<template v-for="(subItem,subIndex) in item.sub">
							<el-menu-item ref="_item" :key="subIndex" @click="$emit('openTab',subItem)" :index="subItem.menuId" v-if="subItem.qx.includes(userinfo.accountType)"
								class="_test">
								{{subItem.title}}
							</el-menu-item>
						</template>
						
					</el-submenu>
					<el-menu-item :key="index" @click="$emit('openTab',item)" :index="item.menuId" v-else-if="item.qx.includes(userinfo.accountType)">
						{{item.title}}
					</el-menu-item>
				</template>
			</el-menu>
		</el-main>
		<el-footer  class="nopading" style="height: auto;">
			<li class="el-submenu _button_cop" @click="isCollapse=!isCollapse">
				<el-button style="width: 100%;">
					<template v-if="isCollapse"><img  src="../assets/double-arrow-right.png" style="width: 1.5rem;height: 1.5rem;"/></template>
					<template v-else><img src="../assets/double-arrow-left.png" style="width: 1.5rem;height: 1.5rem;"/> </template>
				</el-button>
			</li>
		</el-footer>
		<!-- </div> -->
	</el-container>
	<!-- </div> -->
</template>

<script>
	export default {
		name: 'MultiMenu',
		props: {
			menuList: {
				type: Array,
				default: () => []
			},
			TabIndex: {
				type: String,
				default: ''
			}
		},
		computed:{
			TabReal(){
				let curitem=this.$store.getters.GetOpenedTabs.find(item=>item.menuId==this.TabIndex);
				if(!curitem) return '';
				if(curitem['attach']) return curitem['source'];
				return this.TabIndex;
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			},
		},
		data(){
			return {
				isCollapse:false,
				iconfonts:['el-icon-s-data','el-icon-s-check','el-icon-s-opportunity','el-icon-s-claim','el-icon-s-open','el-icon-s-marketing','el-icon-s-tools','el-icon-location']
			}
		}
	}
</script>

<style scoped>
	.fullheigt{
		/* height: calc(100% - 38px); */
		height: 0px;
		overflow: auto;
	}
	.el-menu-vertical-m10 {
		text-align: left;
	}

	.el-menu-vertical-m10:not(.el-menu--collapse) {
		/* width: 8rem; */
		/* min-height: 400px; */
	}
	li .el-button{
		border: none;
	}
	._button_cop{
		background-color: #000000;
		color: #FFFFFF;
	}
	._text_color{
		color: #FFFFFF;
	}
	.nopading{
		padding: 0;
	}
	.el-menu>.el-menu-item{
		color: #FFFFFF;
	}
</style>
